module.exports = __webpack_public_path__ + "img/bg03-bf.45b3a9ae.png";